import { createSlice } from "@reduxjs/toolkit";
import { getChargesTypes } from "../services/chargesTypesService";

let initialState = {
  isLoading: false,
  data: [],
  pages: 0,
  errors: null
};

const chargesTypesSlice = createSlice({
  name: "chargesTypes",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getChargesTypes.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    })
    builder.addCase(getChargesTypes.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = (payload[0] && JSON.parse(payload[0].jsonData)) || [];
      state.errors = null;
    })
    builder.addCase(getChargesTypes.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    })
  }
});

export default chargesTypesSlice.reducer;